const handleDeleteDocumentModalDocEmployee = {
  confirm: 'Do you really want to delete this entry?',
  title: 'DELETE DOCUMENT'
};

export default handleDeleteDocumentModalDocEmployee;
